import React from 'react';
import { stats } from '../data/content';
import { Eyebrow } from './ui/Eyebrow';
export function StatsBar() {
  return <section aria-label="Pakiet w liczbach" className="w-full bg-white" data-id="element-154" data-mp="1tbt8fglgibl3">
      <div className="mx-auto max-w-content px-6 py-12 text-center" data-id="element-155" data-mp="1oavpv2wjbfj2">
        <Eyebrow data-id="element-156" data-mp="1od87tg2alpw4">Liczby, które mówią same za siebie</Eyebrow>

        <dl className="mt-6 grid grid-cols-2 gap-y-6 sm:grid-cols-4 sm:divide-x sm:divide-sand" data-id="element-157" data-mp="1jbiwdzb5ra7i">
          {stats.map(stat => <div key={stat.label} className="px-4" data-id="element-158" data-mp="1ef27h2w4wrtd">
              <dt className="sr-only" data-id="element-159" data-mp="19lg1ftkh7m6j">{stat.label}</dt>
              <dd data-id="element-160" data-mp="15kx8txarec3a">
                <span className="block font-display text-2xl font-bold text-ink" data-id="element-161" data-mp="15ke3dg2apg65">
                  {stat.value}
                </span>
                <span className="mt-1 block text-[9px] font-semibold uppercase tracking-[0.16em] text-muted" data-id="element-162" data-mp="10ndvr0pss5cx">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}